import { environment } from "src/environments/environment";

export const ApplicationConstant = {
    ApplicationID : 36,
    clientId : 20,
    organizationId: environment.organizationId,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD',
    KWAppID: 35
}
